module.exports = __webpack_public_path__ + "static/en-4-40c1eec27f1d7d312dd02aa8df8fae2a.png";